import { useCallback, useMemo } from 'react';
import { List } from 'immutable';
import { DragDropContext, HTML5Backend } from 'react-dnd-compat';

// @ts-expect-error Untyped module
import ColumnSwitcherModal from 'ContentComponents/components/columnSwitcher/ColumnSwitcherModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useReportingFiltersProvider } from '../../providers/ReportingFiltersProvider';
import useUsageTrackerProps from '../../hooks/useUsageTrackerProps';
import { DETAILS_INTERACTION } from '../../constants/trackerEvents';
import { jsx as _jsx } from "react/jsx-runtime";
const MAX_CUSTOM_COLUMNS = 7;
const CustomColumnSwitcherModal = ({
  closeModal,
  isColumnSwitcherOpen
}) => {
  const {
    allMetricsData,
    setMetricsToDisplay,
    metricsToDisplay
  } = useReportingFiltersProvider();
  const {
    tracker
  } = useUsageTrackerProps();
  const getColumnLangKey = useCallback(key => allMetricsData[key].labelKey, [allMetricsData]);
  const updateCustomColumns = updatedColumnsAsImmutableList => {
    const updatedColumns = updatedColumnsAsImmutableList.toArray();
    setMetricsToDisplay(updatedColumns);
    tracker.track(DETAILS_INTERACTION, {
      action: 'changed-source-table-columns'
    });
  };
  const allColumns = useMemo(() => List(Object.keys(allMetricsData)), [allMetricsData]);
  const currentCustomColumns = useMemo(() => List(metricsToDisplay), [metricsToDisplay]);
  return /*#__PURE__*/_jsx(ColumnSwitcherModal, {
    allColumns: allColumns,
    body: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "content-management-details-lib.reporting.customColumnsModal.body",
      options: {
        maxColumns: MAX_CUSTOM_COLUMNS
      }
    }),
    closeModal: closeModal,
    currentCustomColumns: currentCustomColumns,
    getColumnLangKey: getColumnLangKey,
    maxCustomColumns: MAX_CUSTOM_COLUMNS,
    open: isColumnSwitcherOpen,
    requiredColumnNames: List([]),
    setCustomColumns: updateCustomColumns
  });
};
export default DragDropContext(HTML5Backend)(CustomColumnSwitcherModal);